module.exports = __webpack_public_path__ + "static/media/car-alt.758efd9a.svg";